import { SvgIcon, type SvgIconProps } from './svgIcon'

export const InvestorFeeIcon = ({
  width = 24,
  height = 24,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.3692 9.01332C19.5345 8.17862 18.1966 8.1309 17.3046 8.90401L14.2889 11.5176C14.0024 10.3869 12.978 9.55023 11.7582 9.55023H7.27473L3.63456 12.9763L2.92113 12.2628L0 15.184L6.87461 22.0586L9.79574 19.1375L9.09799 18.4397L10.2084 17.3293H13.5897C14.8495 17.3293 16.0577 16.8289 16.9485 15.9381L22.1212 10.7653L20.3692 9.01332ZM12.8687 12.3409V12.1607C12.8687 11.5474 12.3715 11.0502 11.7582 11.0502H7.86959L4.69571 14.0374L8.03733 17.379L9.29419 16.1222C9.48172 15.9347 9.73608 15.8293 10.0013 15.8293H13.5897C14.4517 15.8293 15.2783 15.4869 15.8878 14.8774L19.9999 10.7653L19.3085 10.074C19.0303 9.79575 18.5843 9.77984 18.287 10.0375L14.1099 13.6577C13.9735 13.7759 13.7991 13.8409 13.6187 13.8409H9.14774V12.3409H12.8687ZM3.6029 15.0659L3.58654 15.0813L3.07842 14.5414L2.92113 14.3842L2.12132 15.184L6.87461 19.9373L7.67436 19.1375L3.6029 15.0659Z"
      fill="#121212"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75011 1.75C9.71661 1.75 10.5001 2.5335 10.5001 3.5C10.5001 4.4665 9.71661 5.25 8.75011 5.25C7.78362 5.25 7.00011 4.4665 7.00011 3.5C7.00011 2.5335 7.78362 1.75 8.75011 1.75ZM12.0001 3.5C12.0001 1.70507 10.545 0.25 8.75011 0.25C6.95519 0.25 5.50011 1.70507 5.50011 3.5C5.50011 5.29493 6.95519 6.75 8.75011 6.75C10.545 6.75 12.0001 5.29493 12.0001 3.5Z"
      fill="#121212"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7501 4.75C15.1643 4.75 15.5001 5.08579 15.5001 5.5C15.5001 5.91421 15.1643 6.25 14.7501 6.25C14.3359 6.25 14.0001 5.91421 14.0001 5.5C14.0001 5.08579 14.3359 4.75 14.7501 4.75ZM17.0001 5.5C17.0001 4.25736 15.9928 3.25 14.7501 3.25C13.5075 3.25 12.5001 4.25736 12.5001 5.5C12.5001 6.74264 13.5075 7.75 14.7501 7.75C15.9928 7.75 17.0001 6.74264 17.0001 5.5Z"
      fill="#121212"
    />
  </SvgIcon>
)
